import { render, staticRenderFns } from "./PanelWrap.vue?vue&type=template&id=64dc73e6&scoped=true"
var script = {}
import style0 from "./PanelWrap.vue?vue&type=style&index=0&id=64dc73e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc73e6",
  null
  
)

export default component.exports